import { AgenziaCompagnia } from './agenzia-compagnia';
import { Compagnia } from './compagnia';
import { ModelWithAddressAndContactInfo } from './model-with-address-contact-info';
import { Polizza } from './polizza';

export class Agenzia extends ModelWithAddressAndContactInfo {
  static apiUrl: string = "agenzie";

  nome: string;
  codice: string;

  polizze: Polizza[];
  compagnie: Compagnia[];

  agenzia_compagnia: AgenziaCompagnia[];

  deserialize(input: any): Agenzia {
    let retV: Agenzia = new Agenzia();

    retV = super.deserialize(input) as Agenzia;

    if (input?.polizze) {
      retV.polizze = input.polizze.map(m => new Polizza().deserialize(m));
    }
    if (input?.compagnie) {
      retV.compagnie = input.compagnie.map(m => new Compagnia().deserialize(m));
    }


    return retV;
  }

}
